import React from 'react';
import { motion } from 'framer-motion';
import { AppMockup } from './AppMockup';
interface HeroSectionProps {
  onOrderClick?: () => void;
  onHowItWorksClick?: () => void;
}
export function HeroSection({
  onOrderClick,
  onHowItWorksClick
}: HeroSectionProps) {
  return <section className="relative w-full pt-12 pb-24 px-4 overflow-hidden" data-id="element-183">
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-184">
        {/* Headlines */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-4xl mx-auto mb-6" data-id="element-185">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif italic leading-tight mb-6" data-id="element-186">
            An Audio Guestbook for Weddings That Skips the Rental Hassle
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="max-w-2xl mx-auto mb-10" data-id="element-187">
          <p className="text-cream-400 text-lg md:text-xl leading-relaxed" data-id="element-188">
            Guests record voice messages from their phones using a QR code. You
            keep the toasts, the laughs, and the late-night rambles. Ihsanly
            saves everything with a simple record-and-save flow.
          </p>
        </motion.div>

        {/* CTAs */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 mb-20" data-id="element-189">
          <button onClick={onOrderClick} className="bg-gradient-to-r from-accent-purple to-accent-pink text-white text-sm font-bold tracking-widest uppercase px-8 py-4 rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300 w-full sm:w-auto" data-id="element-190">
            Create Your Audio Guestbook
          </button>
          <button onClick={onHowItWorksClick} className="bg-transparent border-2 border-cream-400/30 text-white text-sm font-bold tracking-widest uppercase px-8 py-4 rounded-full hover:bg-white/5 hover:border-white transition-all duration-300 w-full sm:w-auto" data-id="element-191">
            See How It Works
          </button>
        </motion.div>

        {/* Mockup Container with Floating Badges */}
        <motion.div initial={{
        opacity: 0,
        y: 100
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.8,
        type: 'spring',
        stiffness: 50
      }} className="relative w-full max-w-5xl mx-auto" data-id="element-192">
          {/* Left Badge */}
          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute -top-16 -left-4 md:-left-12 z-20 hidden md:block" data-id="element-193">
            <div className="bg-cream-200 text-brown-900 px-6 py-4 rounded-[2rem] rounded-bl-none shadow-lg transform -rotate-6 max-w-[180px] text-center" data-id="element-194">
              <p className="font-bold text-sm leading-tight" data-id="element-195">
                No $400 Rentals Required
              </p>
            </div>
            <svg className="absolute top-full left-8 w-12 h-12 text-white" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-196">
              <path d="M10,10 C30,50 50,50 80,80" strokeDasharray="5,5" data-id="element-197" />
              <path d="M70,75 L80,80 L75,70" data-id="element-198" />
            </svg>
          </motion.div>

          {/* Right Badge */}
          <motion.div animate={{
          y: [0, -15, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1
        }} className="absolute -top-8 -right-4 md:-right-12 z-20 hidden md:block" data-id="element-199">
            <div className="bg-accent-teal text-brown-900 px-6 py-8 rounded-[3rem] rounded-br-none shadow-lg transform rotate-6 max-w-[160px] text-center flex flex-col items-center justify-center aspect-square" data-id="element-200">
              <p className="font-bold text-sm leading-tight" data-id="element-201">
                Instant Voice Messages
              </p>
            </div>
            <svg className="absolute top-full right-12 w-16 h-16 text-white transform -scale-x-100" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-202">
              <path d="M10,10 C30,40 60,40 90,60" strokeDasharray="5,5" data-id="element-203" />
              <path d="M80,55 L90,60 L85,50" data-id="element-204" />
            </svg>
          </motion.div>

          <AppMockup data-id="element-205" />
        </motion.div>
      </div>
    </section>;
}